var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 180,
    viewBox: "0 0 1440 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_659_4574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 43L24 53.2134C48 63.4267 96 83.5013 144 103.928C192 124.355 240 144.429 288 141.964C336 139.499 384 114.141 432 108.859C480 103.928 528 119.072 576 114.141C624 108.859 672 83.5013 720 86.3188C768 88.7841 816 119.072 864 119.072C912 119.072 960 88.7841 1008 70.8226C1056 53.2134 1104 48.2828 1152 45.4653C1200 43 1248 43 1296 50.7481C1344 58.144 1392 73.6401 1416 81.036L1440 88.7841V180H1416C1392 180 1344 180 1296 180C1248 180 1200 180 1152 180C1104 180 1056 180 1008 180C960 180 912 180 864 180C816 180 768 180 720 180C672 180 624 180 576 180C528 180 480 180 432 180C384 180 336 180 288 180C240 180 192 180 144 180C96 180 48 180 24 180H0V43Z",
    fill: "#DCF2F4"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 48.8049,
    transform: "matrix(-1 0 0 1 14.8045 89.1955)",
    fill: "#FFD771"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 9.87317,
    transform: "matrix(-1 0 0 1 32.4187 10.7707)",
    stroke: "#FFD771",
    strokeWidth: 1.79512
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1431.22,
    cy: 81.5479,
    r: 56.5479,
    fill: "#FFD771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405.36 94.6769L1359.34 121.246V68.1082L1405.36 94.6769Z",
    fill: "#41D2CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.51 94.6781L1396.38 132.28V57.0767L1461.51 94.6781Z",
    fill: "#07878E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.283 51.7041L111.321 74.7764V28.6318L151.283 51.7041Z",
    fill: "#41D2CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.046 51.7047L143.489 84.3578V19.0515L200.046 51.7047Z",
    fill: "#07878E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1329.73,
    cy: 106.73,
    r: 13.1023,
    stroke: "#FFD771",
    strokeWidth: 1.25531
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.73,
    cy: 134.73,
    r: 13.1023,
    stroke: "#FFD771",
    strokeWidth: 1.25531
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1280.53,
    cy: 76.5319,
    r: 7.53188,
    fill: "#FFD771"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.532,
    cy: 137.532,
    r: 7.53188,
    fill: "#FFD771"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1277,
    cy: 29.0013,
    r: 3.37365,
    stroke: "#FFD771",
    strokeWidth: 1.25531
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1319.69,
    cy: 41.0013,
    r: 3.37365,
    fill: "#FFD771",
    stroke: "#FFD771",
    strokeWidth: 1.25531
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2197 133.016L20.3051 142.204L20.3051 123.828L36.2197 133.016Z",
    fill: "#41D2CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6416 133.015L33.1184 146.019V120.012L55.6416 133.015Z",
    fill: "#07878E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_659_4574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 180,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqBg);
export default __webpack_public_path__ + "static/media/faq-bg.fcd3182017541ba2224c71bb3d8f43a7.svg";
export { ForwardRef as ReactComponent };